module.exports = __webpack_public_path__ + "static/img/xtb.f9f4f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xtb.png
// module id = 7CpQ
// module chunks = 0